import React, { Component } from 'react';



export default class ErrComp extends Component {


    constructor(props) {
        super(props);

    }

    render() {

        return (
            <div className="terms" style={{ display:"flex", justifyContent: 'center' }}>
                    <div id='TOUContent' style={{ borderWidth: '0px', borderStyle: 'solid', borderRadius: "5px", width: '275px', height: '275px', borderColor: "grey", backgoundColor: "transparent", padding: "5px 10px 0px 0px" }}>
                        <div className='wh100' id='touText' style={{ verticalAlign: 'top', borderColor: "grey", borderWidth: "0px" }}>
                                    <span id='lblErrMsg' dangerouslySetInnerHTML={{ __html: this.props.ErrMsg }}></span>
                               
                        </div>
                    </div>
                </div>
        );

    }
}
